module.exports = __webpack_public_path__ + "img/dat04.95e059b1.png";